import './css/App.css';
import './css/font-awesome-4.7.0/css/font-awesome.min.css';

import React, { PropTypes, Component } from 'react';

import Banner from './components/banner.jsx';
import MeetingList from './components/meetings.jsx';
import StatusLight from './components/status.jsx';

import { Provider } from 'react-redux';

import { configureStore } from './configureStore';
import { getMeetingsByDate } from './api';

import { Router, Route, browserHistory } from 'react-router';
import moment from 'moment';

const RailTracker = ({ params }) => (
  <div>
    <Banner
      date={params.date || moment().add(1, 'days').format('YYYY-MM-DD') }
    />
    <StatusLight />
    <MeetingList
      date={params.date || moment().add(1, 'days').format('YYYY-MM-DD') }
    />
  </div>
);
RailTracker.propTypes = {
  params: PropTypes.object,
};


const store = configureStore();
setInterval(() => {
  if (document.hidden) return;
  const { date } = store.getState();
  store.dispatch(getMeetingsByDate(date));
}, 30 * 1000);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router history={browserHistory}>
          <Route path="/(:date)" component={RailTracker} />
        </Router>
      </Provider>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/